// Module ids as seeded by backend migration userapp/0003 (Module rows). The
// home page cards navigate with these and the backend's ModuleAccessMiddleware
// enforces them on the module API prefixes.
export const MODULE_COLOR_EXPLORER = "ac8cf3df-a98a-45ed-a53d-d1eb884a07ad";
export const MODULE_IMAGE_REPRODUCTION = "ae6ac1d0-49be-46eb-8d27-a789f6cc92ab";
export const MODULE_SELECTION_EXPLORER = "e569d1e1-feb6-4c8f-89d2-a41005a58b96";

// Names as on the home page cards (the Module rows keep their older seeded
// names, e.g. "Image Reproduction"), in the cards' order.
export const MODULE_LABELS = {
  [MODULE_COLOR_EXPLORER]: "Color Explorer",
  [MODULE_SELECTION_EXPLORER]: "Color Selection",
  [MODULE_IMAGE_REPRODUCTION]: "Color Reproduction",
};
export const MODULE_ORDER = [
  MODULE_COLOR_EXPLORER,
  MODULE_SELECTION_EXPLORER,
  MODULE_IMAGE_REPRODUCTION,
];
